import ListingHistory from "../components/Dash/Test/Listing/listingHistory";
import Nav from "../components/Nav/nav";
import Whatsapp from "../Whatsapp/whatsapp";

const Transactions = () => {
  return (
    <div>
      <Nav />
      <ListingHistory />
      <Whatsapp/>
    </div>
  );
};

export default Transactions;
